import React from 'react'
import IconRadio from './IconRadio'

export default class Radio extends React.Component {
    constructor(props) {
        super(props)
        this.active = this.active.bind(this)
        this.classes = this.classes.bind(this)
        this.icon = this.icon.bind(this)
    }

    active() {
        return this.props.selected == this.props.value
    }

    classes() {
        return Object.assign({}, Styles.button, this.active() && Styles.active)
    }

    icon() {
        return this.active() ? <IconRadio /> : <IconRadio inactive />
    }

    render() {

        return (
            <button
                data-value={this.props.value}
                style={Styles.button}
                {...this.props}>
                <div>
                    {this.icon()}
                </div>

                <div style={Styles.label}>
                    {this.props.children}
                </div>
            </button>
        )
    }
}

const Styles = {
    button: {
        background: 'transparent',
        border: '0',
        cursor: 'pointer',
        display: 'flex',
        marginBottom: '1.5rem',
        maxWidth: '500px',
        outline: '0',
        textAlign: 'left',
        width: '100%'
    },

    label: {
        alignSelf: 'stretch',
        background: 'transparent',
        color: '#777A7D',
        display: 'inline-block',
        flex: '1 1 auto',
        fontSize: '0.9rem',
        fontWeight: '100',
        lineHeight: '1.25rem',
        marginLeft: '1rem',
        textAlign: 'left',
        userSelect: 'none'
    }
}
